import { useSyncExternalStore } from "react";
import { api } from "@/lib/api";

let ids = new Set();
let loaded = false;
const subs = new Set();

const fetchIds = () => api.get("/supporters/ids").then(({ data }) => { ids = new Set(data); subs.forEach((f) => f()); });
const load = () => {
  if (loaded) return;
  loaded = true;
  fetchIds().catch(() => { loaded = false; });
  setInterval(() => document.visibilityState === "visible" && fetchIds().catch(() => {}), 5 * 60 * 1000);
};

const subscribe = (f) => { subs.add(f); load(); return () => subs.delete(f); };

export const useVipIds = () => useSyncExternalStore(subscribe, () => ids);
export const useIsVip = (id) => useSyncExternalStore(subscribe, () => Boolean(id) && ids.has(id));
